const SCORES = [4, 3, 2, 1];

export default function RankQuestion({ q, value, onChange, instruction }) {
  const v = value || {};
  const assign = (opt, s) => {
    const next = {};
    Object.entries(v).forEach(([k, sc]) => {
      if (sc !== s && k !== opt) next[k] = sc;
    });
    if (v[opt] !== s) next[opt] = s;
    onChange(next);
  };
  const hasImages = q.options.some((o) => o.image);

  return (
    <div data-testid={`rank-${q.id}`}>
      <p className="mb-5 rounded-xl bg-[#f5efe6] px-4 py-3 text-sm leading-relaxed text-stone-700" data-testid="rank-instruction">{instruction}</p>
      <div className={hasImages ? "grid grid-cols-1 gap-4 sm:grid-cols-2" : "space-y-3"}>
        {q.options.map((o, i) => (
          <div key={o.value} className="rounded-2xl border bg-white p-4" data-testid={`rank-option-${q.id}-${i}`}>
            {o.image && <img src={o.image} alt={`Imagem ${i + 1}`} className="mb-3 aspect-[4/3] w-full rounded-xl object-cover" />}
            {!hasImages && <p className="text-base font-medium text-stone-800">{o.text}</p>}
            <div className="mt-3 grid grid-cols-4 gap-2" role="radiogroup" aria-label={`Nota para: ${hasImages ? `imagem ${i + 1}` : o.text}`}>
              {SCORES.map((s) => {
                const on = v[o.value] === s;
                const used = !on && Object.values(v).includes(s);
                return (
                  <button
                    key={s}
                    type="button"
                    role="radio"
                    aria-checked={on}
                    onClick={() => assign(o.value, s)}
                    className={`h-12 rounded-xl border font-display text-lg transition-colors ${on ? "border-stone-900 bg-stone-900 text-white" : used ? "border-dashed border-stone-200 text-stone-300" : "border-stone-300 text-stone-700 hover:border-[#c88a2e]"}`}
                    data-testid={`rank-${q.id}-opt${i}-score-${s}`}
                  >
                    {s}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-stone-500">4 = combina mais com você · 1 = combina menos. Ao escolher uma nota já usada, ela muda de alternativa.</p>
    </div>
  );
}
